import React, { useState, useEffect } from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const ScrollButton = () => {
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [showScrollToBottom, setShowScrollToBottom] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollThreshold = documentHeight / 8; // Show buttons when scrolled past one-fourth of the document
      setShowScrollToTop(scrollTop > scrollThreshold);
      setShowScrollToBottom(scrollTop < (documentHeight - windowHeight - scrollThreshold));
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  const buttonStyles = {
    position: 'fixed',
    bottom: '40px',
    right: '20px',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    border: 'none',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
    background: 'rgba(255, 255, 255, 0.8)',
    color: 'gray',
    cursor: 'pointer',
    opacity: 1,
    transition: 'opacity 0.5s ease-in-out',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  };

  return (
    <>
      {showScrollToTop && (
        <button
          onClick={scrollToTop}
          style={{
            ...buttonStyles,
            bottom: '80px',
          }}
        >
          <ArrowUpwardIcon fontSize="small" />
        </button>
      )}
      {showScrollToBottom && (
        <button
          onClick={scrollToBottom}
          style={buttonStyles}
        >
          <ArrowDownwardIcon fontSize="small" />
        </button>
      )}
    </>
  );
};

export default ScrollButton;
